import script from "./indexmain.vue?vue&type=script&setup=true&lang=js"
export * from "./indexmain.vue?vue&type=script&setup=true&lang=js"

import "./indexmain.vue?vue&type=style&index=0&id=7a26927f&scoped=true&lang=css"

import exportComponent from "E:\\李小东项目管理\\23-5\\my-project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a26927f"]])

export default __exports__